import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, Kamitaku } from "@/mixins/index";
import { accLtv, accLtv_currency } from "@/api/dataAll/accountLtv";
export default {
  name: "kamitakuLtv",
  mixins: [tabulation, Kamitaku],
  data: function data() {
    return {
      more: true,
      searchData: {
        kind: 1
      },
      reqFn: accLtv,
      dateList: ['1', '2', '3', '4', '5', '6', '7', '14', '30', '45', '60', '75', '90'],
      nums: [],
      Dynamic: [],
      cellStylekeys: ["LTV"]
    };
  },
  created: function created() {},
  methods: {
    searchClickNew: function searchClickNew() {
      // if(this.currencyClose && !this.searchData.currency_info){
      //   this.$message.error('请选择货币类型')
      //   return
      // }
      var reqFn = this.currencyClose ? accLtv_currency : accLtv;
      this.searchClickPoints(reqFn, 1);
    },
    searchClick: function searchClick(qudata) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, allAmount, DynamicList, k, _k, data, j;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (qudata.length) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                res = {
                  account_total: 0,
                  ltv_data: {},
                  ltv_total: {}
                };
                allAmount = {};
                qudata.forEach(function (i) {
                  res.account_total = res.account_total + i.account_total;
                  res.ltv_data = _objectSpread(_objectSpread({}, res.ltv_data), i.ltv_data);

                  for (var k in i.ltv_data) {
                    for (var j in i.ltv_data[k].amount) {
                      if (!allAmount.hasOwnProperty(j)) {
                        allAmount[j] = 0;
                      }

                      allAmount[j] = allAmount[j] + i.ltv_data[k].amount[j];
                    }
                  }
                });
                DynamicList = [];

                for (k in allAmount) {
                  res.ltv_total[k] = res.account_total ? allAmount[k] / res.account_total : 0;
                  DynamicList.push({
                    label: "LTV".concat(k),
                    prop: 'LTV' + k,
                    tableText: k == 1 ? "LTV".concat(k, "A") : "LTV".concat(k),
                    desc: k == 1 ? _this.$t('firstDayUserAverageValue') : ''
                  });
                }

                _context.next = 9;
                return _this.timeInterval();

              case 9:
                _this.Dynamic = [].concat(DynamicList);
                _this.tableData = [];
                delete res.ltv_total['0'];
                res.ltv_data[_this.$t('total')] = {
                  ltv: res.ltv_total,
                  other: {
                    new_account_num: res.account_total
                  }
                };

                for (_k in res.ltv_data) {
                  data = {
                    date: _k,
                    new_account_num: res.ltv_data[_k].other.new_account_num
                  };

                  for (j in res.ltv_data[_k].ltv) {
                    data['LTV' + j] = res.ltv_data[_k].ltv[j] == '/' ? 0.000 : _this.$utils.conversion(res.ltv_data[_k].ltv[j]).toFixed(3);
                  }

                  _this.tableData.push(data);
                }

                _this.$nextTick(function () {
                  _this.getTableRight();
                });

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    exportdata: function exportdata() {
      var d = {};
      var columns = [{
        label: this.$t('date'),
        prop: 'date'
      }, {
        label: this.$t('registerNumColumnText'),
        prop: 'new_account_num'
      }].concat(_toConsumableArray(this.Dynamic));
      var data = [];
      this.Dynamic.map(function (item) {
        d[item.prop] = 0;
      });
      this.tableData.forEach(function (item) {
        var s = _objectSpread(_objectSpread({}, d), {}, {
          new_account_num: item.new_account_num
        });

        for (var key in s) {
          s[key] = item[key];
        }

        s.date = item.date;
        data.push(s);
      });
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};